export const downloadByteArrayAsFile = (byteArray, fileName, type) => {
    const blob = new Blob([byteArray], { type })
    const url = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url
    a.download = fileName

    document.body.appendChild(a)
    a.click()

    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
}
